import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays the product stock note.
 * Listens for variant update events and swaps in the freshly rendered
 * stock note markup for the newly selected variant.
 */
class ProductStockNote extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateStockNote);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateStockNote);
  }

  /**
   * Updates the stock note.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStockNote = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newNote = event.detail.data.html.querySelector('product-stock-note [ref="stockNoteContainer"]');
    const currentNote = this.querySelector('[ref="stockNoteContainer"]');

    if (!newNote || !currentNote) return;

    if (currentNote.innerHTML !== newNote.innerHTML) {
      currentNote.replaceWith(newNote);
    }
  };
}

if (!customElements.get('product-stock-note')) {
  customElements.define('product-stock-note', ProductStockNote);
}